import { Button, ConfigProvider, Flex, Modal } from "antd";
import React from "react";
import {
  ORGANIZATION_ID,
  PRIMARY_COLOR,
  SERVER_BASE_URL,
  WARNING_COLOR,
} from "../utils";
import axios from "axios";

const ExistingQuote = ({ config, setConfig, data,message }) => {
  const sendEmail = async () => {
    await axios
      .post(
        `${SERVER_BASE_URL}/application/send_email_for_existing_application`,
        {
          organization_id: ORGANIZATION_ID,
          email:
            data?.register_as === "Download Registration Form"
              ? data?.download_gen_email
              : data?.general_email,
        }
      )
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Modal: {
              titleColor: WARNING_COLOR,
            },
          },
        }}
      >
        <Modal
          open={config?.ea_modal_open}
          centered
          footer={null}
          closeIcon={false}
          title={
            <p style={{ textAlign: "center" }}>
               {message}
            </p>
          }
        >
          {config?.send_email ? (
            <Flex
              align="center"
              justify="center"
              style={{ marginTop: "1rem" }}
              vertical
              gap={20}
            >
              You will receive an email shortly to registered email.
              <ConfigProvider
                theme={{
                  token: { colorPrimary: PRIMARY_COLOR },
                }}
              >
                <Button
                  onClick={() => {
                    setConfig({
                      ...config,
                      ea_modal_open: false,
                      send_email: false,
                    });
                  }}
                  style={{ width: "fit-content", margin: "auto" }}
                >
                  Close
                </Button>
              </ConfigProvider>
            </Flex>
          ) : config?.contact_support ? (
            <Flex
              align="center"
              justify="center"
              style={{ marginTop: "1rem" }}
              vertical
              gap={20}
            >
              <p>
                {" "}
                Please Mail us at
                <strong style={{ marginLeft: "5px" }}>
                  {" "}
                  <a
                    style={{ color: "#454545", fontSize: "16px" }}
                    href={`mailto:sales@recprotect.ca`}
                  >
                    sales@recprotect.ca
                  </a>
                </strong>{" "}
              </p>
              <ConfigProvider
                theme={{
                  token: { colorPrimary: PRIMARY_COLOR },
                }}
              >
                <Button
                  onClick={() => {
                    setConfig({
                      ...config,
                      ea_modal_open: false,
                      contact_support: false,
                    });
                  }}
                  style={{ width: "fit-content", margin: "auto" }}
                >
                  Close
                </Button>
              </ConfigProvider>
            </Flex>
          ) : (
            <Flex
              vertical
              gap={20}
              style={{ marginTop: "1.5rem" }}
              align="center"
            >
              <ConfigProvider
                theme={{
                  token: { colorPrimary: PRIMARY_COLOR },
                }}
              >
                <Button
                  type="primary"
                  onClick={() => {
                    setConfig({ ...config, send_email: true });

                    sendEmail();
                  }}
                >
                  Send existing application link to registered email
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: PRIMARY_COLOR,
                    // colorPrimaryHover: WARNING_COLOR,
                  },
                }}
              >
                <Button
                  type="primary"
                  onClick={() => {
                    setConfig({ ...config, contact_support: true });
                  }}
                >
                  Contact Support
                </Button>
              </ConfigProvider>
              <ConfigProvider
                theme={{
                  token: { colorPrimary: PRIMARY_COLOR },
                }}
              >
                <Button
                  onClick={() => {
                    setConfig({ ...config, ea_modal_open: false });
                  }}
                  style={{ width: "fit-content", margin: "auto" }}
                >
                  Close
                </Button>
              </ConfigProvider>
            </Flex>
          )}
        </Modal>
      </ConfigProvider>
    </div>
  );
};

export default ExistingQuote;
